import axios from 'axios'
import AuthApi from 'app/services/core/login.service'
import EnvConstants from 'app/services/core/config.service'

const apiPath = `${EnvConstants.API_BASE}/client-state-service/state`
const hubPrefix = 'ckla-hub'

const getApiUrl = (key: string) =>
  `${apiPath}/${AuthApi.getUserBk()}/${hubPrefix}-${key}`

const getRequestConfig = () => ({
  headers: {
    authorization: `Bearer ${AuthApi.getAccessToken()}`,
  },
})

export const getClientStateData = async (key: string) => {
  const response = await axios.get(getApiUrl(key), getRequestConfig())
  return response.data
}

export const setClientStateData = (key: string, setData: any) =>
  axios.post(getApiUrl(key), setData, getRequestConfig())

export const deleteClientStateData = (key: string) =>
  axios.delete(getApiUrl(key), getRequestConfig())
